export const ISSUE_STATUS_VALUE = {
  PENDING: 2,
  ACTIVE: 1,
  CLOSED: 0,
}

export const REPORT_ISSUE = {
  TH: 'รายงานปัญหา',
  EN: 'Report Issue'
}

export const ISSUE_ERROR_CONTENT = {
  TH: 'เกิดปัญหาในการส่งปัญหาของคุณ โปรดลองอีกครั้ง',
  EN: 'There was a problem submitting your issue, Please try again.',
}
